function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EligibilityAnswers } from "../../models/Eligibility";
import { PreferenceAnswers } from "../../models/Preferences/PreferenceAnswers";
import { loadState } from "../../store/Utilities/State";
import { getStoredIntakes } from "../StudentOnboarding/storage/Intakes/localStorage";
import { getFieldsOfEducationIdCategory, getFieldsOfEducationIdSubcategory } from "../StudentOnboarding/storage/FieldsOfEducation/localStorage";
import { getAcceptableCountries } from "../StudentOnboarding/storage/Countries/localStorage";
import { getStoredProgramLevelFamily } from "../StudentOnboarding/storage/ProgramLevelFamilies/localStorage";
export var AnonOnboardingAnswers = /*#__PURE__*/function () {
  function AnonOnboardingAnswers(eligibility, preferences) {
    _classCallCheck(this, AnonOnboardingAnswers);
    this.complete = eligibility.complete && preferences.complete;
    this.discreteSchemeGrade = eligibility.discreteSchemeGrade;
    this.duolingoScore = eligibility.duolingoScore;
    this.gmatScore = eligibility.gmatScore;
    this.greScore = eligibility.greScore;
    this.highestEducation = eligibility.highestEducation;
    this.ieltsScore = eligibility.ieltsScore;
    this.nationality = eligibility.nationality;
    this.numericSchemeGrade = eligibility.numericSchemeGrade;
    this.pteScore = eligibility.pteScore;
    this.residency = eligibility.residency;
    this.schemelessGrade = eligibility.schemelessGrade;
    this.studyPermits = eligibility.studyPermits;
    this.toeflScore = eligibility.toeflScore;
    this.noEnglishScore = eligibility.noEnglishScore;
    this.countries = preferences.countries;
    this.fieldsOfEducation = preferences.fieldsOfEducation;
    this.intakes = preferences.intakes;
    this.programLevelFamilies = preferences.programLevelFamilies;
  }
  _createClass(AnonOnboardingAnswers, null, [{
    key: "getData",
    value:
    // needed for quick search
    function getData() {
      var application = loadState().CefApplication.application;
      return {
        application: application,
        studentPreferences: {
          countries: getAcceptableCountries(),
          programLevelFamily: getStoredProgramLevelFamily(),
          fieldOfEducation: [].concat(_toConsumableArray(getFieldsOfEducationIdCategory()), _toConsumableArray(getFieldsOfEducationIdSubcategory())),
          intakes: _toConsumableArray(getStoredIntakes())
        }
      };
    }
  }, {
    key: "fromStorage",
    value: function fromStorage() {
      return new AnonOnboardingAnswers(EligibilityAnswers.fromStorage(), PreferenceAnswers.fromStorage());
    }

    // Eligibility

    // Preferences
  }]);
  return AnonOnboardingAnswers;
}();